// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__aBaLn","white":"Logo_white__qh0tX","slide-in-out":"Logo_slide-in-out__PK5m9","fade-in-out":"Logo_fade-in-out__b_Ho2"};